module.exports = __webpack_public_path__ + "img/nasolabial_male_average.1ae33f89.png";